import React from 'react';
import {
  DatepickerField, InputField, RadioField,
} from '../../Forms/Fields';
import { AssetAdvisoryFormValues, useAssetAdvisoryAccordions } from './useAssetAdvisoryForm';
import { InvestmentProfiles } from '../../../utils/constants';
import { ControlledAccordionItem } from '../../common/ControlledAccordion';

export function ClientAccordion() {
  const {
    isClientAccordionFilled,
  } = useAssetAdvisoryAccordions();
  return (
    <ControlledAccordionItem
      button={{ title: 'Datos del cliente' }}
      eventKey="0"
      isFilled={isClientAccordionFilled}
      isOpenRequired
    >
      <div className="d-flex flex-column gap-4">
        <InputField<AssetAdvisoryFormValues>
          id="name"
          path="name"
          label="¿Cuál es tu nombre?"
          placeholder="Ingresar nombre"
        />
        <DatepickerField<AssetAdvisoryFormValues>
          id="date_of_birth_field"
          path="date_of_birth"
          label="¿Cuál es tu fecha de nacimiento?"
        />
        <RadioField<AssetAdvisoryFormValues>
          path="profile"
          label={(
            <>
              ¿Cuál es tu perfil de inversionista?
              {' '}
              <span className="fw-normal">Si no sabes revisa</span>
              {' '}
              <a href="https://banco.bice.cl/inversiones/aprende-a-invertir/conoce-tu-perfil/encuesta" target="_blank" rel="noreferrer">aquí</a>
            </>
              )}
          options={InvestmentProfiles.asRadioOptions<AssetAdvisoryFormValues>()}
          optionsDirection="vertical"
        />
      </div>

    </ControlledAccordionItem>
  );
}
